<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" @keyup.enter="load">
                <b-row class="my-3 align-items-center">
                    <b-col cols="6">

                        <LgFinderPageUnidadeAdministrativa :prefix="title.join(' > ') + ' > '" v-model="departamento"
                            @onselect="selectDepartamento" id="finderPageUnidadeAdministrativaConsultarAutorizacao"
                            label="Departamento:" />
                    </b-col>

                    <b-col cols='4'>
                        <b-row class="align-items-center">
                            <b-col>
                                <lg-form-input class="mt-3" v-model="pesquisa" label=" "></lg-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button id="localizar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                                <b-tooltip target="localizar" title="Localizar" triggers="hover"></b-tooltip>
                            </div>
                        </b-button>
                        <b-button id="Limpar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="Limpar" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>
                        <b-button id="novo" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            @click="showModalNovaAutorizacao" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="nova" title="Adicionar nova..." triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-row>

                <b-row>
                    <lg-form-input class="mt-3" v-model="qtdRequisicoesComplete" disabled label=" "></lg-form-input>
                </b-row>
            </b-card>
            <b-card bg-variant="light" class="mt-3">
                <b-table responsive class="mt-2" small show-empty :busy="busy" :items="records" :fields="fields" hover
                    @row-dblclicked="onDblClickAutorizacao">
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(dataCriacao)="data">
                        <span v-if="data.item.dataCriacao">
                            {{ formatDate(data.item.dataCriacao) }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>
                    <template v-slot:cell(status)="data">
                        <b-badge :variant="badgeVariant(data.item.status)" class="badge">
                            {{ formatSituacao(data.item.status) }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-row class='justify-content-end '>
                            <b-button
                                v-if="(((data.item.tipoCompra == TipoRequisicaoCompraEnum.LICITACAO.cod ||  data.item.tipoCompra == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod)) && data.item.orcamentoNumero && data.item.status === StatusEnum.AUTORIZACAO_COMPRA_APROVADO.value) ||
                                (((data.item.tipoCompra != TipoRequisicaoCompraEnum.LICITACAO.cod &&  data.item.tipoCompra != TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod))   && data.item.status === StatusEnum.AUTORIZACAO_COMPRA_APROVADO.value) "
                                :id="data.index + 'enviar-button'" class="my-2 mx-1" size="sm" pill variant="success"
                                @click="alterarStatus(data.item.id, data.item.autorizacaoNumero, StatusEnum.AUTORIZACAO_COMPRA_FINALIZADO.value, 'enviar')">
                                <b-icon icon="box-arrow-right" />
                                <b-tooltip :target="data.index + 'enviar-button'" title="Enviar"></b-tooltip>
                            </b-button>

                            <b-button
                                v-if="!data.item.orcamentoNumero && data.item.status === StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value"
                                :id="data.index + 'edit-button'" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="editar(data.item)">
                                <b-icon icon="pencil-square" />
                                <b-tooltip :target="data.index + 'edit-button'" title="Editar"></b-tooltip>
                            </b-button>
                            <b-button :id="data.index + 'visualizar-button'" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="visualizar(data.item)">
                                <b-icon icon="eye" />
                                <b-tooltip :target="data.index + 'visualizar-button'" title="Visualizar"></b-tooltip>
                            </b-button>
                            <b-button
                                v-if="((data.item.tipoCompra == TipoRequisicaoCompraEnum.LICITACAO.cod ||  data.item.tipoCompra == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod) && !data.item.orcamentoNumero && data.item.status === StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value) "
                                :id="data.index + 'orcamento-button'" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="mostrarFinderOrcamento(data.item)">
                                <b-icon icon="file-earmark-text" />
                                <b-tooltip :target="data.index + 'orcamento-button'" title="Orçamento"></b-tooltip>
                            </b-button>

                            <b-button
                                v-if="(((data.item.tipoCompra == TipoRequisicaoCompraEnum.LICITACAO.cod ||  data.item.tipoCompra == TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod) && data.item.orcamentoNumero && data.item.status === StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value)) ||
                                (data.item.tipoCompra != TipoRequisicaoCompraEnum.LICITACAO.cod &&  data.item.tipoCompra != TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod &&  data.item.status === StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value)"
                                :id="data.index + 'approve-button'" class="my-2 mx-1" size="sm" pill variant="success"
                                @click="alterarStatus(data.item.id, data.item.autorizacaoNumero, StatusEnum.AUTORIZACAO_COMPRA_APROVADO.value, 'aprovar')">
                                <b-icon icon="check-circle" />
                                <b-tooltip :target="data.index + 'approve-button'" title="Aprovar"></b-tooltip>
                            </b-button>
                            <b-button
                             v-if="data.item.status === StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value"
                                :id="data.index + 'reject-button'" class="my-2 mx-1" size="sm" pill variant="danger"
                                @click="alterarStatus(data.item.id, StatusEnum.AUTORIZACAO_COMPRA_REJEITADO.value, 'rejeitar')">
                                <b-icon icon="x-circle" />
                                <b-tooltip :target="data.index + 'reject-button'" title="Rejeitar"></b-tooltip>
                            </b-button>
                        </b-row>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <ConsultarAutorizacoesForm v-if="mostrarModalForm" :prefix="title.join(' > ') + ' > '"
                :idAutorizacao="selectedAutorizacaoId" :isViewMode="isViewMode" @close='fecharModalNovaAutorizacao' />
        </b-card-body>
        <LgFinderPageOrcamento @close="esconderFinderModal" :autorizacaoSelecionada="autorizacaoSelecionada"
            :situacaoFixa="StatusEnum.ORCAMENTO_EM_ANDAMENTO.value" :modalOnly="true"
            :prefix="title.join(' > ') + ' > '" v-if="mostrarOrcamento" @rowSelect="rowSelect"
            id="finderPageOrcamentoAutorizacao" />
    </b-card>
</template>

<script>
import ConsultarAutorizacoesForm from "./ConsultarAutorizacoesForm.vue"
import AutorizacaoCompraService from "@/core/api/AutorizacaoCompraService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import StatusEnum from "@/core/utils/StatusEnum"
import Swal from "sweetalert2"
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPageOrcamento from "@/components/Finders/LgFinderPageOrcamento.vue"
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum"
export default {
    components: {
        LgFinderPageOrcamento,
        ConsultarAutorizacoesForm,
        LgFormInput,
        LgFinderPageUnidadeAdministrativa
    },
    mixins: [ListResourceMixin],

    props: {
        verificarOrcamento: {
            type: Boolean,
            default: null
        },
        status: {
            type: Number,
            default: null,
        },
        consultaDetalhada: {
            type: Boolean,
            default: false,
        },
    },
    name: "ConsultarAutorizacaoCompra",
    data() {
        return {
            TipoRequisicaoCompraEnum:TipoRequisicaoCompraEnum,
            autorizacaoSelecionada: {},
            mostrarModalForm: false,
            mostrarOrcamento: false,
            qtdRequisicoesAprovadasTexto: 'Quantidade de Requisições a serem aprovadas: ',
            qtdRequisicoesComplete: '',
            departamento: {},
            pesquisa: "",
            title: ["Consultar Autorizações de Compra"],
            selectedAutorizacaoId: null,
            fields: [
                { key: "autorizacaoNumero", label: "Nº Autorização" },
                { key: "orcamentoNumero", label: "Nº Orçamento" },


                { key: "desricaoTipoCompra", label: "Tipo Compra" },
                { key: "valorAprovado", label: "Valor Aprovado" },
                { key: "departamento", label: "Unidade Administrativa" },
                { key: "dataCriacao", label: "Data Documento" },
                { key: "status", label: "Status" },
                { key: "actions", label: "" },
            ],
            currentPage: 1,
            perPage: 10,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
            isViewMode: false,
            actionType: '',
            selectedItem: null,
            selectedAutorizacaoNumero: null,
            action: '',
            StatusEnum,
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/autorizacao-compra`);
        this.$serviceRequisicao = new ResourceService(`/api/requisicoes-compra`);

        this.load()
    },
    methods: {
        esconderFinderModal() {
            this.mostrarOrcamento = false;
            this.load();
        },
        mostrarFinderOrcamento(item) {
            this.autorizacaoSelecionada = item;
            this.mostrarOrcamento = true;
        },
        rowSelect() {
            this.autorizacaoSelecionada = {}
            this.mostrarOrcamento = false;
            this.load();

        },
        selectDepartamento(item) {
            this.departamento = item;
            this.load();
        },
        async load() {
            this.busy = true
            this.filtro = {};
            if (this.verificarOrcamento)
                this.filtro.verificarOrcamento = this.verificarOrcamento;

            if (this.status)
                this.filtro.status = this.status;

            if (this.pesquisa)
                this.filtro.pesquisa = this.pesquisa;

            if (this.departamento && this.departamento.id) {
                this.filtro.departamento = this.departamento.id;
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            var { data } = await this.$serviceRequisicao.get('quantidade-aprovar')

            this.qtdRequisicoesComplete = this.qtdRequisicoesAprovadasTexto + data;
        },
        showModalNovaAutorizacao() {
            this.mostrarModalForm = true;
        },
        fecharModalNovaAutorizacao() {
            this.selectedAutorizacaoId = null
            this.isViewMode = false
            this.mostrarModalForm = false;
            this.load()
        },
        editar(autorizacao) {
            this.selectedAutorizacaoId = autorizacao.id
            this.mostrarModalForm = true;
        },
        visualizar(autorizacao) {
            this.selectedAutorizacaoId = autorizacao.id
            this.isViewMode = true
            this.mostrarModalForm = true;

        },
        formatSituacao(situacao) {
            return StatusEnum.fromValue(situacao).descricao || "N/A"
        },
        badgeVariant(situacao) {
            const variants = {
                [StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO.value]: "primary",
                [StatusEnum.AUTORIZACAO_COMPRA_APROVADO.value]: "success",
                [StatusEnum.AUTORIZACAO_COMPRA_REJEITADO.value]: "danger",
            }
            return variants[situacao] || "secondary"
        },
        clearForm() {
            this.pesquisa = ''
            this.load()
        },
        onDblClickAutorizacao(item) {
            this.$emit('onDblClickAutorizacao', item)
        },
        confirmAction(actionType, item) {
            this.actionType = actionType
            this.selectedItem = item
            this.$refs.confirmActionModal.show()
        },
        closeConfirmActionModal() {
            this.$refs.confirmActionModal.hide()
            this.actionType = ''
            this.selectedItem = null
        },
        updateStatus(id, statusId) {
            AutorizacaoCompraService.updateStatus(id, statusId)
                .then(() => {
                    this.$notify({
                        message: 'Status alterado com sucesso',
                        type: 'success',
                        title: 'Sucesso',
                    })
                    this.load()
                })
                .catch(() => {
                    Swal.fire('Erro', 'Ocorreu um erro ao atualizar o status.', 'error')
                })
        },
        alterarStatus(id, autorizacaoNumero, statusId, action) {
            Swal.fire({
                title: `Tem certeza que deseja ${action} a autorização número ${autorizacaoNumero}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(() => {
                this.updateStatus(id, statusId)
            })
        },
        fecharConfirmModal() {
            this.$refs.confirmModal.hide()
            this.selectedAutorizacaoId = null
            this.selectedAutorizacaoNumero = null
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const [datePart] = dateString.split("T")
            const [year, month, day] = datePart.split("-")
            return `${day}/${month}/${year}`
        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
